import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Button, StyledInput, theme } from "~/components/Common";

const styledName = "AddMemberForm";

export const StyledTextInput = styled(StyledInput, { name: styledName })({
  "&": {
    width: "100%",
    marginTop: "40px",
    ".MuiInputBase-root": {
      border: `1px solid ${theme.palette.primary.main}`,
      width: "100%",
    },
  },
});

export const StyledLabel = styled(Typography, { name: styledName })({
  "&": {
    fontSize: "1.6rem",
    textAlign: "start",
    marginTop: "20px",
  },
});

export const StyledShareButton = styled(Button, { name: styledName })({
  "&": {
    float: "right",
    marginTop: "20px",
  },
});
